// Routes with subroutes possible see: https://reactrouter.com/web/example/route-config
// Note: subroute components would display on page WITH parent route component

import { matchPath } from 'react-router-dom';
import deepmerge from 'deepmerge';
import {
  COMPONENT_INDEX,
  COMPONENT_NOTFOUND,
  COMPONENT_COACHINGREQUESTMANAGEMENTDETAIL,
  COMPONENT_COACHINGREQUESTMANAGEMENTLIST,
  MAINTENANCE_MODE, VIRTUAL_DIRECTORY,
} from './constants';
import { setChildProperty } from './object';
import { getEnvironmentConstant } from './utilities';
import logger from './logger';
import XHRError from './xhrError';

export const validateStillOffered = (data) => {
  if (!data.stillOffered) {
    throw new XHRError(404, 'content has been retired');
  }
};
// Common route definition used by SSR and CSR
export const defaultRoutes = [
  {
    path: '/',
    componentKey: COMPONENT_INDEX,
    exact: true,
  },
  {
    path: '/index.html',
    componentKey: COMPONENT_INDEX,
    exact: true,
  },
  {
    path: '/request/list',
    componentKey: COMPONENT_COACHINGREQUESTMANAGEMENTLIST,
    exact: true,
  },
  {
    path: '/request/list/:type',
    componentKey: COMPONENT_COACHINGREQUESTMANAGEMENTLIST,
    exact: false,
  },
  {
    path: '/request/detail/:coachingRequestId',
    componentKey: COMPONENT_COACHINGREQUESTMANAGEMENTDETAIL,
    exact: false,
  },
  {
    path: '*',
    componentKey: COMPONENT_NOTFOUND,
    status: 404,
  },

];

export const maintenanceRoutes = [
  {
    path: '*',
    componentKey: MAINTENANCE_MODE,
    status: 200,
  },
];

// Called from SSR /server/lib/render.tsx to fetch associated server-side data for a route.
export const getDataForPath = async (props) => {
  const {
    path, env, isMaintenanceMode, isSSR,
  } = props;
  const routes = isMaintenanceMode ? maintenanceRoutes : defaultRoutes;

  const matchedRoute = routes
    .map((route) => ({ route, match: matchPath(path.replace(getEnvironmentConstant({ key: VIRTUAL_DIRECTORY, env }), ''), route) }))
    .filter((combined) => combined.match !== null);
  let returnedData = {};
  let editorialData = {};
  logger.info('getDataForPath matchedRoute:', JSON.stringify(matchedRoute));

  if (isSSR && returnedData && matchedRoute[0].route.storeDataObject) {
    if (!returnedData.error) {
      // Handle wrapping data with store slice structure for SSR
      const splitStore = matchedRoute[0].route.storeDataObject.split('|');

      if (splitStore.length > 1 && Array.isArray(returnedData)) {
        const newData = {};
        splitStore.forEach((storeKey, idx) => {
          setChildProperty(returnedData[idx], storeKey, newData);
        });
        returnedData = newData;
      } else {
        returnedData = setChildProperty(returnedData, matchedRoute[0].route.storeDataObject, {});
      }
      returnedData[matchedRoute[0].route.storeDataObject.split('.')[0]].isLoaderVisible = false;
    }
  }

  if (isSSR && editorialData && matchedRoute[0].route.editorialDataObject) {
    if (!editorialData.error) {
      // Handle wrapping data with store slice structure for SSR
      editorialData = setChildProperty(editorialData, matchedRoute[0].route.editorialDataObject, {});
    }
  }

  if (matchedRoute[0] && matchedRoute[0]?.route?.status) {
    if (returnedData) {
      returnedData.status = matchedRoute[0].route.status;
    } else {
      returnedData = { status: matchedRoute[0].route.status };
    }
  }

  return deepmerge(returnedData, editorialData);
};
